import { render, staticRenderFns } from "./SetariPreturiTransport.vue?vue&type=template&id=0f3de8bd&scoped=true"
import script from "./SetariPreturiTransport.vue?vue&type=script&lang=js"
export * from "./SetariPreturiTransport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3de8bd",
  null
  
)

export default component.exports